export default "__VITE_ASSET__jZIWF0Rh__"